import { render, staticRenderFns } from "./newComponent.vue?vue&type=template&id=75049aa7&"
import script from "./newComponent.vue?vue&type=script&lang=js&"
export * from "./newComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports